import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

// Replace with your actual backend URL
const API_URL = 'https://kcademy.onrender.com/api';
//const API_URL = 'http://localhost:3000/api';

export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async (credentials) => {
    const response = await axios.post(`${API_URL}/users/login`, credentials);
    return response.data;
  }
);

export const signupUser = createAsyncThunk(
    'auth/signupUser',
    async (credentials) => {
      const response = await axios.put(`${API_URL}/users/create`, credentials);
      //console.log(response.data)
      return response.data;
      
    }
  );
  
  
export const getJobs = createAsyncThunk(
  'auth/getJobs',
  async (credentials) => {
    const response = await axios.put(`${API_URL}/jobs/jobs`, credentials);
    //console.log(response.data)
    return response.data;
    
  }
);

// Async action to post a job
export const createJob = createAsyncThunk(
  'jobs/createJob',
  async (jobData, { getState, rejectWithValue }) => {
    try {
      jobData.user = localStorage.getItem('user')
      const { auth } = getState(); // Get token from auth slice
      const response = await axios.post(
        `${API_URL}/jobs/jobs`,
        jobData,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`
          }
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchJobs = () => async (dispatch, getState) => {
  const token = getState().auth.token;

  try {
    const res = await axios.get(`${API_URL}/jobs/jobs`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    dispatch({ type: 'JOBS_SUCCESS', payload: res.data });
  } catch (err) {
    dispatch({ type: 'JOBS_FAIL' });
  }
};

export const deleteJob = (id) => async (dispatch, getState) => {
  const token = getState().auth.token;

  try {
    await axios.delete(`${API_URL}/jobs/jobs/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    dispatch({ type: 'JOB_DELETED', payload: id });
  } catch (err) {
    console.error(err);
  }
};


export const updateJob = (job) => async (dispatch, getState) => {
  try {
    const token = getState().auth.token;

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    };

    const { data } = await axios.put(
      `${API_URL}/jobs/jobs/${job._id}`,
      job,
      config
    );

    dispatch({ type: 'UPDATE_JOB_SUCCESS', payload: data });
  } catch (err) {
    console.error('Update failed:', err.response?.data?.message || err.message);
  }
};
